module.exports = __webpack_public_path__ + "img/close--white.58a1e521.svg";